
export default {
  data () {
    return {
      maxHeight:sessionStorage.getItem('maxHeight'),
      devType: (process.env.API_TYPE === "dev"),
      version:'',
      showTip:false
    }
  },
  mounted: function() {
   
  },
  methods: {
    getLastHeigh: function() {
      return 100;
    },
  }
}